<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
                    <BreadcrumbItem>{{ titleType==1?"新品荟":'臻品荟' }}统计</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">详情页</div>
            </div>
            <div class="f-tar" style="padding-top: 37px;">
                <Button @click="$router.go(-1)">返回</Button>
            </div>
        </div>


        <div class="layout-content" style="background: transparent;">
            <div style="background: #fff;">
                <el-descriptions title="" :column="2" style="padding:20px 40px 0 40px">
                    <el-descriptions-item label="产品名称">{{ dataQuery.productName }}</el-descriptions-item>
                    <el-descriptions-item label="联系人">
                        <span v-for="(item3, index3) in contactsList" :key="index3">
                            {{ item3.name }}
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="产品类别">{{ dataQuery.productCategory ? dataQuery.productCategory :
                        '' }}</el-descriptions-item>
                    <el-descriptions-item label="职务">
                        <span v-for="(item6, index6) in contactsList" :key="index6">
                            {{ item6.jobTitle }}
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="浏览量">{{ dataQuery.countNum }}</el-descriptions-item>
                    <el-descriptions-item label="手机">
                        <span v-for="(item5, index5) in contactsList" :key="index5">
                            {{ item5.mob }}
                        </span>
                    </el-descriptions-item>
                    <el-descriptions-item label="公司名称">{{ company }}</el-descriptions-item>
                    <el-descriptions-item label="邮箱">
                        <span v-for="(item4, index4) in contactsList" :key="index4">
                            {{ item4.email }}
                        </span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <!-- <div v-if="list.length"> -->
            <div v-if="tableList.length">
                <Table :columns="columns" :loading="loading" :data="tableList">
                    <template slot-scope="{ row }" slot="name">{{ row.userName ? row.userName : '' }}</template>
                    <template slot-scope="{ row }" slot="userId">{{ row.userId }}</template>
                    <template slot-scope="{ row }" slot="comm">
                        {{ row.compName ? row.compName : '' }}
                    </template>
                    <template slot-scope="{ row }" slot="job">
                        {{ row.jobTitle }}
                    </template>
                    <template slot-scope="{ row }" slot="tel">
                        {{ row.phoneNumber }}
                    </template>
                    <template slot-scope="{ row }" slot="email">
                        {{ row.email }}
                    </template>
                    <template slot-scope="{ row }" slot="address">
                        {{ row.country }}
                        {{ row.province }}
                        {{ row.city }}
                        {{ row.county }}
                    </template>
                    <template slot-scope="{ row }" slot="times">
                        {{ row.inTime | dateFormat }}
                    </template>
                </Table>
                <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
                    <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
                        @on-change="changePage" @on-page-size-change="changePageSize" />
                </div>
            </div>
            <div class="u-empty" v-else>暂无数据</div>
        </div>

       
        <div class="catalogue-content"></div>

    </div>
</template>
  
<script>
import { mapGetters, mapActions } from 'vuex'
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
    name: 'exhibition-info-carApply',
    data () {
        return {
            newsAudit: "0",
            productTypeOptions: [
                {
                    value: '选项1',
                    label: '黄金糕',
                },
            ],
            productTypeValue: '',

            modalDetail: false,
            loading: false,

            editBrand: false,
            editBrandnfo: null,
            editTopic: false,
            editTopicnfo: null,
            search: '',
            editInfo: null,
            pageSize: 20,
            pageIndex: 1,
            totalCount: 0,
            columns: [

                {
                    title: '姓名',
                    slot: 'name',
                    align: 'center',
                },
                {
                    title: 'userId',
                    slot: 'userId',
                    align: 'center',
                },
                {
                    title: '公司',
                    slot: 'comm',
                    align: 'center',
                },
                {
                    title: '职务',
                    slot: 'job',
                    align: 'center',
                },
                {
                    title: '手机',
                    slot: 'tel',
                    align: 'center',
                },
                {
                    title: '邮箱',
                    slot: 'email',
                    align: 'center',
                },
                {
                    title: '地区',
                    slot: 'address',
                    align: 'center',
                },
                {
                    title: '浏览时间',
                    slot: 'times',
                    align: 'center',
                },

            ],

            oppTime: [],
            searchField: '',
            list: [],
            selection: [], // 选中项目
            addShow: false,
            rejectModel: false,
            modelTitle: '',
            rowUser: {},
            showTabs: '0',
            PoptipTitle: '',
            option: {},
            stateInit: '',
            rejectValue: '',
            form: {
                category: [], // 展品分类
            },
            type: [],
            contactsList: [],
            tableList: [],
            idCategory: '',
            proIdType: "fcb459d0-9565-413b-832d-f25bba4c3567",
            statusProType: ['wait'],
            excelOpt: {},
            dataQuery: {},
            titleType:"",
            company:"",
        }
    },
    components: {
        // exhibitionCarYes,
        // exhibitionCarNo
    },
    computed: {
        ...mapGetters({
            exhibition: 'loginModule/getExhibition',
            exhibitionInfo: 'hostSetModule/getHostExhibition',
            hostExhibition: 'hostSetModule/getHostExhibition',

        }),
    },
    async created () {
        this.dataQuery = JSON.parse(this.$route.query.data)
        this.titleType = (this.$route.query.type)
        document.title = '中国国际医疗器械博览会 - 产品审核详情'
        // this.initProType()
        // this.init()
        this.rejectP()
    let res= await this.getCompanyByJoinOne(this.dataQuery.compId)
    this.company = res.name
    
        

    },
    methods: {
        ...mapActions({
            getHostBuySupply: 'hostSetModule/getHostBuySupply',
            putHostUpdateState: 'hostSetModule/putHostUpdateState',
            getHostCallingAgain: 'hostSetModule/getHostCallingAgain',
            getBuyExport: 'hostSetModule/getBuyExport',
            //   商机
            busOppNewRealeaseGetPageList:
                'hostSetModule/busOppNewRealeaseGetPageList',
            getProductByGroupId: 'categoryModule/getProductByGroupId', // 获取  产品类别
            busOppNewRealeasePutUpdate: 'hostSetModule/busOppNewRealeasePutUpdate', // 修改
            busOppNewRealeaseExcelExportHost:
                'hostSetModule/busOppNewRealeaseExcelExportHost',
            newRealeaseSetIsShow: 'hostSetModule/newRealeaseSetIsShow',
            getByCompId: 'hostSetModule/getByCompId',
            getAllBindsById: 'hostSetModule/getAllBindsById',

            getAuditLogPass: 'hostSetModule/getAuditLogPass',
            getAuditLogPut: 'hostSetModule/getAuditLogPut',
            postProductTagCount: 'hostSetModule/postProductTagCount',

            postExcelExportTagCount: 'hostSetModule/postExcelExportTagCount',
            getCompanyByJoinOne: 'hostSetModule/getCompanyByJoinOne',


            postProductTagAuditLogPage: 'hostSetModule/postProductTagAuditLogPage',
        }),
        switchBrand (name) {
            this.pageIndex = 1
            this.init()
        },

        initStatus () {
            this.pageIndex = 1
            if (this.newsAudit == 0) {
                this.statusProType = ['wait']
            }
            if (this.newsAudit == 1) {
                this.statusProType = ['pass', 'notpass']
            }
            this.init()

        },
        searchChick () {
            this.init()
            //     this.startDateStr = this.formatDate(this.oppTime[0])
            //   this.endDateStr = this.formatDate(this.oppTime[1])
        },
        // 转换日期格式
        formatDate (dateTime) {
            let date = new Date(dateTime)
            let YY = date.getFullYear() + '-'
            let MM =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '-'
            let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            let hh =
                (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            let mm =
                (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                ':'
            let ss =
                date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            //    return YY + MM + DD + " " + hh + mm + ss;
            return YY + MM + DD
        },

        async init () {

            let a = [
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 6,
                        Label: 'Cname',
                        Value: `%${this.searchField || ''}%`,
                    },
                },
            ]

            let pushList = this.searchField ? a : {}

            let pushList1 = [
                {
                    type: 1,
                    Wheres: {
                        WhereOperator: 6,
                        Label: 'ProductCategory',
                        Value: `%${this.searchField || ''}%`,
                    },
                },
            ]


            this.option = {
                tagId: this.proIdType,
                dataType: this.showTabs == '0' ? 'page' : 'product',
                countType: this.showTabs == '2' ? 'follow' : 'preview',
                pageType: this.newsAudit == '0' ? 'wechat' : 'pcen',
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
                // Wheres: {}
                Wheres: {
                    type: 0,
                    Wheres: {
                        WhereGroupOperator: 0,
                        Predicates: this.showTabs == 0 ? pushList : pushList1,
                    },
                },
            }
            console.log(this.option, 'pppppppp')

            this.excelOpt = this.option

            this.loading = true
            let proData = await this.postProductTagCount(this.option)
            if (proData) {
                this.loading = false
                // this.list = proData.items
                let resList = proData.items
                this.pageSize = proData.pageSize
                this.pageIndex = proData.pageIndex
                this.totalCount = proData.totalCount
                resList.forEach((e) => {
                    if (e.productCategory) {
                        const category = JSON.parse(e.productCategory)
                        const categoryArr = []
                        if (category) {
                            if (category.Value) {
                                categoryArr.push(category.Value)
                                if (category.List[0]) {
                                    categoryArr.push(category.List[0].Value)
                                    if (category.List[0].list) {
                                        categoryArr.push(category.List[0].list[0].Value)
                                    }
                                }

                                e.productCategory = categoryArr.join('/')
                            }
                        }
                    }
                })
                this.list = resList
                console.log(this.list, '[][][][][][][][]')
            } else {
                this.loading = false
            }
        },

        // 查询产品类别
        async initProType () {
            let categoryData = await this.getProductByGroupId({
                groupId: this.hostExhibition.groupId,
                level: 0,
                loadChild: true,
            }) // 暂时先写死了值
            if (categoryData && categoryData.length) {
                categoryData.map((c) => {
                    c.value = c.name
                    c.label = c.name
                    c.children = JSON.parse(JSON.stringify(c.list))
                    c.children.map((v) => {
                        v.value = v.name
                        v.label = v.name
                        v.children = JSON.parse(JSON.stringify(v.list))
                        v.children.map((z) => {
                            z.value = z.name
                            z.label = z.name
                            z.children = JSON.parse(JSON.stringify(z.list))
                        })
                    })
                })
                this.type = categoryData
                console.log(this.type, '888888888')
            } else {
                this.type = []
            }
        },

        async setAllAudit () {
            const reqList = []
            if (!this.selection.length) return
            this.selection.forEach((c) => {
                reqList.push(c.joinId)
            })
            const bool = await this.setOneStepAudit({
                joinIds: reqList,
            })
            if (bool && bool.successed) {
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
        },
        changePage (e) {
            this.pageIndex = e
            this.init()
        },
        changePageSize (e) {
            this.pageSize = e
            this.init()
        },
        edit (item) {
            this.editInfo = item
        },
        searchPro () {
            this.pageIndex = 1
            this.init()
        },
        changeEvent (selection) {
            this.selection = selection
        },
        async rejectP (row, index) {

            this.contactsList = await this.getByCompId(this.dataQuery.compId)
            console.log(this.contactsList, '所有联系人');

            this.tableList = await this.getAllBindsById(this.dataQuery.id)
            console.log(this.tableList, 'ip和关注人');



            // getByCompId
            // this.rejectValue = ''
            // this.rowUser = row
            // this.modelTitle = '详情：'
            // this.rejectModel = true
            //   }
        },

        // 驳回确定按钮
        async handleSubmitReject () {
            if (!this.rejectValue) {
                this.$Message.warning('驳回理由不能为空！')
                return
            }
            const option = {
                // id: this.rowUser.id,
                id: this.rowUser.id,
                setValues: {
                    Remark: this.rejectValue,
                    AuditStatus: 'notpass',
                },
            }
            let bool = await this.getAuditLogPut(option)
            if (bool && bool.successed) {
                this.rejectModel = false
                this.$Message.success('操作成功')
                this.init()
            } else {
                this.$Message.error('操作失败，请重新尝试')
            }
            //   }
        },

        // 获取产品类别
        changeCategory (val) {
            let category = this.form.category
            if (val) {
                category = this.form.category = val
            }
            let data = null
            this.type.forEach((c) => {
                if (category[0] && c.name === category[0]) {
                    this.idCategory = c.id
                    data = {
                        Id: c.id,
                        Value: c.name,
                        List: [],
                    }
                    if (c.list && c.list.length && category[1]) {
                        c.list.forEach((v) => {
                            if (v.name === category[1]) {
                                this.idCategory = v.id
                                data.List[0] = {
                                    Id: v.id,
                                    Value: v.name,
                                }
                                if (v.list && v.list.length && category[2]) {
                                    v.list.forEach((j) => {
                                        if (j.name === category[2]) {
                                            this.idCategory = j.id
                                            data.List[0].list = [
                                                {
                                                    Id: j.id,
                                                    Value: j.name,
                                                    Remark: j.tag,
                                                },
                                            ]
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
            console.log(this.idCategory)
            return data
        },

        // 修改展品显示、屏蔽
        async showToggle (item) {
            const bool = !!item.isShow
            let result = await this.newRealeaseSetIsShow({
                id: item.id,
                setValues: {
                    IsShow: bool,
                },
            })
            if (result.successed) {
                this.$Message.success('修改成功')
                this.init()
            } else {
                this.$Message.error('修改失败，请重新尝试')
            }
        },

        // 展商导出
        async hostExcelExportBack () {

            let res = await this.postExcelExportTagCount(this.excelOpt)
            let filename = "新品荟统计导出.xlsx";
            const blob = new Blob([res], { type: 'application/vnd.ms-excel' }); // 构造一个blob对象来处理数据，并设置文件类型
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                navigator.msSaveBlob(blob, filename);
            } else {
                const href = URL.createObjectURL(blob); // 创建新的URL表示指定的blob对象
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = href; // 指定下载链接
                a.download = filename; // 指定下载文件名
                a.click();
                URL.revokeObjectURL(a.href); // 释放URL对象
            }
            this.$Message.success("导出成功，耐心等待");

        },
    },
}
</script>
  
<style scoped lang="scss">
.catalogue {
    .header-tool {
        min-height: 90px;
    }

    &-content {
        min-width: 1000px;
        margin: 24px;
        padding: 40px;
        min-height: 500px;
        padding-bottom: 190px;
    }
}

.cib {
    min-width: 1000px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
}

.spanClass {
    margin-left: 4px;
    margin-right: 4px;
}

.deleteClass {
    color: #f78989;
    // cursor:pointer;
}

.lookClass {
    color: #1890ff;
    cursor: pointer;
}

.marLeft {
    margin-left: 15px;
}
</style>
  